import React from 'react';
import _ from 'lodash';

import { Dialog } from '@tencent/spaui';

import LeadsPushDataFormat from '../../../../consts/LeadsPushDataFormat';
import PrivilegeCode from '../../../../consts/PrivilegeCode';
import RuleApplyRange from '../../../common/RuleApplyRange';
import useRuleApplyRange from '../../../hooks/useRuleApplyRange';

const MyDialog = (props) => {
  const {
    ruleName,
    leadsPushUrl,
    appToken,
    appSecret,
    bundleFieldMap,
    customQaFieldMap, // 展示互动内容字段 by fighting
    standardFieldMap,
    constFieldMap,
    applyRange,
    dimension,
    dimensionValues,
    pushDataFormat,
    pushTemplate,
    model = 'edit',
  } = props.data;

  const applyRangeHooks = useRuleApplyRange({
    data: applyRange,
    model,
  });

  const getSubTypeList = () => (
    // let res = [];
    // if (!applyRange || !applyRange.applyRangeDetail || applyRange.applyRangeType == 'ALL') {
    //     return (<p className="read-des">所有</p>);
    // }
    // applyRange.applyRangeDetail.forEach((field) => {
    //     const key = field.fieldName;
    //     if(field.fieldScope == 'BUNDLE') {
    //         res.push(<p className="read-des">{key + ': ' + field.fieldValues.join(',')}</p>);
    //     } else if (key == 'leadsSource') {
    //         res.push(<p className="read-des">{scopeMap[key] + ': ' + field.fieldValues.map(ele => leadsSourceMap[ele]).join(',')} </p>);
    //     } else if (key == 'actionSubType__leadsSubType') {
    //         res.push(<p className="read-des">{scopeMap[key] + ': ' + field.fieldValues.map(ele => actionSubType[ele] || Tags.leadsSubTypeTag[ele].desc).join(',')}</p>);
    //     } else {
    //         res.push(<p className="read-des">{scopeMap[key] + ': ' + field.fieldValues.join(',')}</p>);
    //     }
    // })
    // return res;
    <div className="config-li">
      <div className="form-in"></div>
      <div className="form-in">
        <RuleApplyRange {...applyRangeHooks} disabledAllField={true} />
      </div>
    </div>
  );
  const renderObject = (obj) => {
    const res = [];
    _.forEach(obj, (ele, key) => {
      res.push(
        <tr>
          <td>{key}</td>
          <td>{ele}</td>
        </tr>,
      );
    });

    return res;
  };
  return (
    <Dialog
      backdrop
      type="normal"
      show={props.show}
      onClose={props.onClose}
      onSubmit={props.onClose}
      onCancel={props.onClose}
      title={`${ruleName}接口配置`}
      style={{
        width: '700px',
      }}
      cancelButton={false}
      submitButton={false}
      className="modal-set-height customrule-dialog"
    >
      <div className="apiconfig-des">
        <div className="form-list-normal form-list-read">
          <div className="lump">
            <div className="lump-bd">
              <ul className="infos">
                <li className="infolist">
                  <span className="info-tt">推送地址</span>
                  <div className="info-des">
                    <p className="read-des">{leadsPushUrl}</p>
                  </div>
                </li>
                <li className="infolist">
                  <span className="info-tt">密钥</span>
                  <div className="info-des">
                    <p className="read-des">{appSecret}</p>
                  </div>
                </li>
                <li className="infolist">
                  <span className="info-tt">Token</span>
                  <div className="info-des">
                    <p className="read-des">{appToken}</p>
                  </div>
                </li>
                <li className="infolist">
                  <span className="info-tt">映射关系设置</span>
                  <div className="info-des">
                    <div className="field-display">
                      <table>
                        <thead>
                          <tr>
                            <th>原始字段名</th>
                            <th>转换后字段名</th>
                          </tr>
                        </thead>
                        <tbody>{renderObject(standardFieldMap)}</tbody>
                      </table>
                    </div>
                  </div>
                </li>
                <li className="infolist">
                  <span className="info-tt">表单字段设置</span>
                  <div className="info-des">
                    <div className="field-display">
                      <table>
                        <thead>
                        <tr>
                          <th>原始字段名</th>
                          <th>转换后字段名</th>
                        </tr>
                        </thead>
                        <tbody>{renderObject(bundleFieldMap)}</tbody>
                      </table>
                    </div>
                  </div>
                </li>
                <li className="infolist">
                  <span className="info-tt">互动内容字段设置</span>
                  <div className="info-des">
                    <div className="field-display">
                      <table>
                        <thead>
                        <tr>
                          <th>原始字段名</th>
                          <th>转换后字段名</th>
                        </tr>
                        </thead>
                        <tbody>{renderObject(customQaFieldMap)}</tbody>
                      </table>
                    </div>
                  </div>
                </li>
                <li className="infolist">
                  <span className="info-tt">自定义字段设置</span>
                  <div className="info-des">
                    <div className="field-display">
                      <table>
                        <thead>
                          <tr>
                            <th>原始字段名</th>
                            <th>转换后字段名</th>
                          </tr>
                        </thead>
                        <tbody>{renderObject(constFieldMap)}</tbody>
                      </table>
                    </div>
                  </div>
                </li>
                {window.pageProps.privilegesInWhite.includes(PrivilegeCode.LEADS_PUSH_RULE_TEMPLATE.getCode()) &&
                  pushDataFormat == LeadsPushDataFormat.TEMPLATE.getCode() && (
                    <li className="infolist">
                      <span className="info-tt">模板设置</span>
                      <div className="info-des">
                        <p className="read-des">{pushTemplate}</p>
                      </div>
                    </li>
                  )}
                <li className="infolist">
                  <span className="info-tt">适用范围</span>
                  <div className="info-des">{getSubTypeList()}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default MyDialog;
